import { render, staticRenderFns } from "./Tos_202609.vue?vue&type=template&id=f33dc902&scoped=true"
import script from "./Tos_202609.vue?vue&type=script&lang=js"
export * from "./Tos_202609.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/document.css?vue&type=style&index=0&id=f33dc902&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33dc902",
  null
  
)

export default component.exports